// extracted by mini-css-extract-plugin
export default {"userImg":"styles_userImg__TW45z"};